/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Help_LinkInputs */

const de_auth_mfa_help_link = /** @type {(inputs: Auth_Mfa_Help_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hilfe-Center`)
};

/** @type {(inputs: Auth_Mfa_Help_LinkInputs) => LocalizedString} */
const en_auth_mfa_help_link = de_auth_mfa_help_link;

/**

* @param {Auth_Mfa_Help_LinkInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_help_link = /** @type {((inputs?: Auth_Mfa_Help_LinkInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Help_LinkInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_help_link(inputs)
	return en_auth_mfa_help_link(inputs)
});